/**
 * @packageDocumentation
 * Utility for creating spine-driven and textured buttons with consistent styling and interaction wiring.
 */
import * as PIXI from "pixi.js";  
import { Spine } from "@esotericsoftware/spine-pixi-v8"; 
import { Assets } from 'pixi.js';
import { loadGameAssets } from '../LoadAssets';
import { brightnessFilter,shockwave } from "../Game/global";

/**
 * Button class that extends PIXI.Container to create interactive buttons
 * @extends PIXI.Container
 */
export class Button extends PIXI.Container{
    /** Background sprite for the button */
    ButBg!:PIXI.Sprite;
    /** Text displayed on the button */
    ButtonText!:PIXI.Text;
    /** Glow animation for the button using Spine */
    btnGlowAnim!:Spine

    /**
     * Creates a new Button instance
     * @param ButBgName - The name of the background asset to use
     * @param ButText - Object containing text configuration
     * @param ButText.text - The text to display on the button
     * @param ButText.fontSize - The font size for the button text
     * @param ButText.fontFamily - The font family to use for the text
     */
    constructor(private ButBgName:string,private ButText:{text:string, fontSize:number,fontFamily:string}){ 
        super()
        this.createBtn()
    }

    /**
     * Creates the button by setting up the background and text
     * @private
     */
    createBtn(){
        // const Playbut = new PIXI.Container()
        this.ButBg = new PIXI.Sprite(Assets.get(this.ButBgName));
        this.ButBg.anchor.set(0.5);
        this.ButBg.scale.set(1); 
         this.ButtonText = new PIXI.Text({text:this.ButText.text,style:{
            fontFamily: this.ButText.fontFamily, 
            align:"center",
            fill: 'white', 
            fontSize: this.ButText.fontSize,
            fontWeight: 'lighter',
            stroke:{
                color:"black",
                width:4,
                join:"round"
            },
            letterSpacing:4
        }});
        this.ButtonText.anchor.set(0.5);
        // this.ButtonText.filters = [new PIXI.BlurFilter(1)]

        // this.ButtonText.y = -3;
        this.addChild(this.ButBg,this.ButtonText)
        // this.parent.addChild(this)  
    }

    /**
     * Adds interactive functionality to the button
     * @param callback - Function to execute when button is clicked
     * @typeParam T - Return type of the callback function
     */
    addInteraction<T>(callback:()=>T){
        this.interactive = true;
        this.cursor = "pointer"; 
        this.on("pointertap",callback);
        this.on("pointerover",()=>{
            this.filters = [brightnessFilter] 
        }) 
        this.on("pointerout",()=>{
            this.filters = [] 
            this.children.forEach(ele=>{
                ele.scale.set(1);
            })
        })
        this.on("pointerdown",()=>{
            this.children.forEach(ele=>{
                ele.scale.set(0.95);
            })
        });
        this.on("pointerup",()=>{
            console.log("pointerup")
            this.children.forEach(ele=>{
                ele.scale.set(1);
            })
        });
    }

    /**
     * Sets the position of the button text
     * @param x - X coordinate for the text
     * @param y - Y coordinate for the text
     */
    setTextPosition(x:number,y:number){
        this.ButtonText.x = x;
        this.ButtonText.y = y; 
    }

    /**
     * Adds a glow animation to the button using Spine
     * @param data - Configuration object for the spine animation
     * @param data.skeleton - Path to the skeleton file
     * @param data.atlas - Path to the atlas file
     * @param data.scale - Scale factor for the animation
     */
    formBtnGlow(data:{skeleton:string,atlas:string,scale:number}){
         this.btnGlowAnim = Spine.from(data);  
        //  this.addChildAt(this.btnGlowAnim,0) 
    }
}
